/** Persist return target when HR opens attendance from Run Payroll. */
export const PAYROLL_RUN_RETURN_ID_KEY = "payrollRunReturnId";

export const rememberPayrollRunReturn = (payrollId) => {
    if (payrollId != null && payrollId !== "") {
        sessionStorage.setItem(PAYROLL_RUN_RETURN_ID_KEY, String(payrollId));
    }
};

export const readPayrollRunReturnId = () => sessionStorage.getItem(PAYROLL_RUN_RETURN_ID_KEY);

export const clearPayrollRunReturn = () => {
    sessionStorage.removeItem(PAYROLL_RUN_RETURN_ID_KEY);
};

export const resolvePayrollRunId = ({
    payrollId,
    sessionPaySlipId,
    PaySlipId,
    editDetails,
    payrollData,
} = {}) =>
    payrollId
    || sessionPaySlipId
    || PaySlipId
    || editDetails?.id
    || payrollData?.id
    || readPayrollRunReturnId()
    || null;

export const navigateBackToPayrollRun = (navigate, payrollId) => {
    const id = payrollId || readPayrollRunReturnId();
    if (!id) {
        navigate("/payroll/payrollprocess");
        return;
    }
    navigate("/payroll/runpayrollprocess", { state: { PaySlipId: Number(id) || id } });
};
